import { network } from 'services/network';
import { useMutation } from 'react-query';

const mutationFn = ({ id }: QueryParams) => {
    const url = `api/bo/deleteCardAssociatedDocument?docId=${id}`;
    return network.post(url).then((response) => response.data);
};

export const useMutationDeleteExternalDocument = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    id?: number;
}
